export default __webpack_public_path__ + "static/media/Nykaaman.8d47a71b.PNG";